import BaseProxy from './Proxy';

export default class SubstoreSubscriptionBeginProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/subscriptionBegin', parameters);
  }
}
